const nonTrackingGameActionOptions = [
  { label: "Create Incident", value: "create_incident" },
  {
    label: "Resend Entire Game (Network)",
    value: "resend_entire_game_network",
  },
];

export default nonTrackingGameActionOptions;
